import React from 'react';
import CartRecommendationsSkeleton from './CartRecommendationsSkeleton';

const CartBodySkeleton: React.FC<{isCartPage: boolean}> = ({ isCartPage }) => (
  <div className={`h-full flex flex-col gap-8 ${isCartPage ? 'md:flex-row' : ''}`}>
    <div className="flex-1 flex flex-col">
      {/* Header Skeleton */}
      <div className="flex items-center justify-between gap-5 flex-wrap mb-8 px-2.5 min-h-12.5 md:min-h-24 bg-gray-200">
        <div className="h-12.5 w-40 bg-gray-300 rounded"></div>
        <div className="h-12.5 w-full max-w-40 bg-gray-300 rounded-full"></div>
      </div>

      {/* Cart Items Skeleton */}
      <div className="flex-1 flex flex-col gap-4 overflow-y-auto">
        {[...Array(3)].map((_, index) => (
          <div
            key={index}
            className="flex items-center gap-7 bg-gray-200 px-2 py-1 md:gap-8 md:px-4 md:pt-4"
          >
            <div className={`w-full h-full aspect-[120/117] max-w-30 max-h-30 bg-gray-300 rounded shadow-md ${isCartPage ? 'md:max-w-55.5 md:max-h-55.5' : ''}`}></div>
            <div className="flex-1 h-full flex flex-col justify-between self-start gap-4 md:py-2">
              <div className={`flex flex-col gap-4 ${isCartPage ? 'md:flex-row md:justify-between' : ''}`}>
                <div className="w-full flex flex-col">
                  <div className="h-4 bg-gray-300 rounded mb-2 w-5/12"></div>
                  <div className="h-4 bg-gray-300 rounded mb-2 w-4/12"></div>
                  <div className="h-4 bg-gray-300 rounded mb-2 w-3/12"></div>
                  <div className="h-4 bg-gray-300 rounded mb-2 w-4/12"></div>
                </div>
                <div className={`flex gap-2 ${isCartPage ? 'md:flex-col md:gap-0.5' : ''}`}>
                  <div className="w-12.5 h-4 bg-gray-300 rounded"></div>
                  <div className="w-12.5 h-4 bg-gray-300 rounded"></div>
                </div>
              </div>
              <div className={`self-auto flex items-center flex-wrap gap-3 justify-between ${isCartPage ? 'sm:self-end md:gap-9' : ''}`}>
                <div className="w-14 h-4 bg-gray-300 rounded"></div>
                <div className="flex items-center gap-4">
                  <div className="w-6 h-6 bg-gray-300 rounded-full"></div>
                  <div className="w-1 h-6 bg-gray-300 rounded"></div>
                  <div className="w-6 h-6 bg-gray-300 rounded-full"></div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <CartRecommendationsSkeleton isCartPage={isCartPage} />
    </div>

    {/* Order Summary Skeleton */}
    <div className="flex flex-col p-2.5 bg-gray-200 md:flex-1 md:max-w-[474px]">
      <div className="h-6 w-40 bg-gray-300 rounded mb-4"></div>
      <div className="flex items-center justify-between mb-2">
        <div className="w-2/12 h-4 bg-gray-300 rounded"></div>
        <div className="w-1/12 h-4 bg-gray-300 rounded"></div>
      </div>
      <div className="flex items-center justify-between mb-2">
        <div className="w-3/12 h-4 bg-gray-300 rounded"></div>
        <div className="w-1/12 h-4 bg-gray-300 rounded"></div>
      </div>
      <div className="flex items-center justify-between mb-2">
        <div className="w-3/12 h-4 bg-gray-300 rounded"></div>
        <div className="w-4/12 h-4 bg-gray-300 rounded"></div>
      </div>
      <div className="flex items-center justify-between mb-4">
        <div className="w-2/12 h-4 bg-gray-300 rounded"></div>
        <div className="w-4/12 h-4 bg-gray-300 rounded"></div>
      </div>
      <div className="w-full h-px bg-gray-300 mb-4"></div>
      <div className="flex items-center justify-between mb-2">
        <div className="w-2/12 h-4 bg-gray-300 rounded"></div>
        <div className="w-1/12 h-4 bg-gray-300 rounded"></div>
      </div>
      <div className="mt-4 h-10 bg-gray-300 rounded-full"></div>
    </div>
  </div>
);

  export default CartBodySkeleton;
